import componentsReducer, { ComponentsActions } from "@toolkit/Framework/Store/Toolkit/Components/ComponentsReducer";
import pagesReducer, { PagesActions } from "@toolkit/Framework/Store/Toolkit/Pages/PagesReducer";
import { combineReducers } from "redux";

const toolkitReducer = combineReducers({
    components: componentsReducer,
    pages: pagesReducer,
});

export type ToolkitActions = ComponentsActions | PagesActions;

export default toolkitReducer;
